import React from 'react';
import clsx from 'clsx';

type ButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'ghost' | 'danger' | 'success';
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  as?: React.ElementType;
  children: React.ReactNode;
  htmlFor?: string; // For label support
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'secondary',
  size = 'md',
  as: Component = 'button',
  className,
  children,
  type,
  htmlFor,
  ...props
}) => {
  // Default type="button" for actual buttons to prevent accidental form submissions
  const buttonType = Component === 'button' ? (type ?? 'button') : undefined;

  return (
    <Component
      className={clsx(
        'ui-button',
        `ui-button--${variant}`,
        `ui-button--${size}`,
        className
      )}
      type={buttonType}
      htmlFor={Component === 'label' ? htmlFor : undefined}
      {...props}
    >
      {children}
    </Component>
  );
};
